// extracted by mini-css-extract-plugin
export default {"container":"PldRiZ","title":"r0c4Yt","text":"XiTj8u"};